import React, { forwardRef } from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import Button from './Button'

const PrimaryButton = forwardRef(({ children, className, disabled, ...rest }, ref) => (
  <Button
    ref={ref}
    className={classnames({ 'bg-monaLisaPink': !disabled, 'bg-sharkBlack': disabled }, className)}
    disabled={disabled}
    {...rest}
  >
    {children}
  </Button>
))

PrimaryButton.propTypes = {
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
}

PrimaryButton.defaultProps = {
  loading: false,
  disabled: false,
}

export default PrimaryButton
